import { put, call, take, every, takeLatest, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import { toast } from "react-toastify";
import { LOGIN, SING_UP } from "../../services/ApiCalls";

function* signUpSaga({ payload, callBack }) {
  try {
    const response = yield call(SING_UP, payload);
    if (response.data.status == "success") {
      toast.success(response?.data?.message);
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
    }
  } catch (error) {
    toast.error("something went wrong");
  }
}
function* loginSaga({ payload, callBack }) {
  try {
    const response = yield call(LOGIN, payload);
    if (response.data.status == "success") {
      localStorage.setItem("token", response?.data?.data?.token);
      localStorage.setItem("name", response?.data?.data?.businessName);

      localStorage.setItem("_id", response?.data?.data?._id);
      localStorage.setItem("profileImage", response?.data?.data?.profileImage);
      toast.success(response?.data?.message);
      callBack && callBack();
      yield put(ACTION.logInSuccess(response?.data?.data));
    } else {
      yield put(ACTION.logInFail(response?.data?.data));
      toast.error(response?.data?.message);
    }
  } catch (error) {
    toast.error("something went wrong");
  }
}

function* authSaga() {
  yield takeEvery(CONST.SIGN_UP, signUpSaga);
  yield takeEvery(CONST.LOGIN, loginSaga);
}

export default authSaga;
